import Vue from 'vue';
import VConsole from 'vconsole';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/assets/css/te-cutsom.min.css';
import '@/assets/css/te-single-signon.min.css';
import i18n from './i18n';
// 載入FB SDK
import '@/services/application';

Vue.config.productionTip = false;

// 網址參數有"vconsole=1"時顯示VConsole
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('vconsole')) {
  new VConsole({ theme: 'dark' });
}

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
  vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
